import { AdminApiError } from './_core.js';

export interface MeUser {
  id: string;
  email: string;
  emailVerified: boolean;
  name: string | null;
  locale: string;
  timezone: string;
  tenantId: string;
}

export async function fetchMe(): Promise<MeUser | null> {
  const res = await fetch('/api/auth/me', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (res.status === 401) return null;
  if (!res.ok) throw new AdminApiError(res.status, 'me_failed', `HTTP ${res.status}`);
  const json = (await res.json()) as { user?: MeUser };
  return json.user ?? null;
}

export async function signIn(email: string, password: string): Promise<void> {
  const res = await fetch('/api/auth/signin', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Orborix-App': 'admin',
    },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({ error: 'signin_failed' }))) as { error?: string };
    throw new AdminApiError(res.status, body.error ?? 'signin_failed', body.error ?? 'sign in failed');
  }
}

export async function signOut(): Promise<void> {
  await fetch('/api/auth/signout', {
    method: 'POST',
    credentials: 'include',
    headers: { 'X-Orborix-App': 'admin' },
  });
}
